// extracted by mini-css-extract-plugin
export default {"header":"Styles_header__UnKhg","title":"Styles_title__JBuOZ","button":"Styles_button__opBVs"};